<template>
  <div class="" v-if="index != null">
    <vs-tabs v-model="index">
      <vs-tab
        :label="'Floor' + i"
        @click="onChangeFloor"
        v-for="i in $store.getters['i_APC/floor'].length"
        :key="i"
      >
        <TabFloor
          v-if="
            $store.getters['i_APC/schedule_light'] != undefined &&
            $store.getters['i_APC/schedule_air'] != undefined
          "
          :numDevice="$store.getters['i_APC/numDevice'][i - 1]"
          :schedule_light="$store.getters['i_APC/schedule_light'][i - 1]"
          :schedule_breaker="$store.getters['i_APC/schedule_breaker'][i - 1]"
          :schedule_air="$store.getters['i_APC/schedule_air'][i - 1]"
        />
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import TabFloor from "./components/Floor/TabFloor.vue";
export default {
  components: { TabFloor },
  data() {
    return {
      index: null,
      beforeIndex: null,
      // numDevice: [
      //   { light: 1, air: 2 },
      //   { light: 1, air: 1 },
      //   { light: 1, air: 1 },
      //   { light: 1, air: 2 },
      // ],
    };
  },
  async mounted() {
    this.index = parseInt(this.$route.params.index);
    this.beforeIndex = parseInt(this.$route.params.index);

    // hooks params change
    const urlChange = () => {
      // Do your logic here
      this.index = parseInt(this.$route.params.index);
      this.beforeIndex = parseInt(this.$route.params.index);
      console.log("change floor EventListener");
    };
    window.addEventListener("popstate", urlChange);

    // Useful for cleanup when component is destroyed
    this.cleanup = urlChange;
    // this.schedule_air = Array.from({ length: this.floor.length }, (v, i) =>
    //   Array.from({ length: 2 }, (v, i) => [])
    // );
    // this.schedule_air[0].push('1')
    // console.log(this.schedule_air);
    await this.$store.dispatch("i_APC/getSensor");

    this.$store.dispatch("i_APC/genData");
    await this.$store.dispatch("i_APC/getSchedule");
  },
  // Or use destroyed
  beforeDestroy() {
    // It is important to remove the handler when component is getting destroyed
    window.removeEventListener("popstate", this.cleanup);
  },
  methods: {
    onChangeFloor() {
      console.log("change floor");
      if (this.beforeIndex != this.index) {
        this.beforeIndex = this.index;
        this.$router.push({
          name: "I-APC-Floor",
          params: {
            index: this.index,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bt {
  border: red 2px solid;
}
</style>